import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsSlashdotComponent } from './simple-icons-slashdot.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsSlashdotComponent ],
    exports:      [ SimpleIconsSlashdotComponent ],
    bootstrap:    []
})
export class SimpleIconsSlashdotModule {}
